/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_CtaInputs */

const en_directory_footer_cta = /** @type {(inputs: Directory_Footer_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit your tool`)
};

const zh_directory_footer_cta = /** @type {(inputs: Directory_Footer_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交工具`)
};

/**
* | output |
* | --- |
* | "Submit your tool" |
*
* @param {Directory_Footer_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_cta = /** @type {((inputs?: Directory_Footer_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_cta(inputs)
	return zh_directory_footer_cta(inputs)
});
export { directory_footer_cta as "directory.footer.cta" }